import { ReduxStore } from 'store/types';

function getAllEmptyMessage(state: ReduxStore): string {
  return state.manufacturer.getAll.config.emptyMessage;
}

export default getAllEmptyMessage;
